import type { StreamDefinition } from '../../signalr/types'
import {
  type SubscribeGridViewportAction,
  addOrUpdateSecuritiesCache,
  fetchGridViewStateFailed
} from './actions'
import {
  createSecurityFromResponse,
  SECURITIES_BUFFER_DELAY,
  type SecurityResponse
} from './helpers'
import { type HasNsKey, getSecurityMiniFilter } from './selectors'
import { QuoteReliability, type MiniSecurityFilter } from './types'

const getBoundGetSecuritiesByIdParams = (
  state: HasNsKey,
  action: SubscribeGridViewportAction
): [number[], Required<MiniSecurityFilter>] => {
  const { securityIds, gridIndex } = action.payload
  const miniFilter = getSecurityMiniFilter(state)(gridIndex)
  const qr = Number(miniFilter.qr)
  const filterSize = Number(miniFilter.filterSize)

  return [
    securityIds
      .map((securityId) => Number(securityId))
      .filter(
        (securityId) => Number.isSafeInteger(securityId) && securityId > 0
      ),
    {
      qr:
        Number.isSafeInteger(qr) &&
        qr >= QuoteReliability.All &&
        qr <= QuoteReliability.Firm
          ? qr
          : QuoteReliability.All,
      filterSize:
        Number.isSafeInteger(filterSize) && filterSize >= 0 ? filterSize : 0
    }
  ]
}

export const subscribeGridViewportDefinition: StreamDefinition<
  [number[], Required<MiniSecurityFilter>],
  SecurityResponse[],
  SubscribeGridViewportAction,
  HasNsKey
> = {
  method: 'GetSecuritiesById',
  strategy: 'merge',
  shouldProcess: (action) => action.payload.securityIds.length > 0,
  getParams: getBoundGetSecuritiesByIdParams,
  mapResponse: (securities) =>
    addOrUpdateSecuritiesCache(securities.map(createSecurityFromResponse)),
  mapError: (err, action) =>
    fetchGridViewStateFailed(action.payload.gridIndex, err),
  cancelOn: ['securities.subscribeGridViewport'],
  cancelFilter: (cancelAction: SubscribeGridViewportAction, triggerAction) =>
    cancelAction.payload.gridIndex === triggerAction.payload.gridIndex &&
    cancelAction.payload.callId !== triggerAction.payload.callId,
  bufferMs: SECURITIES_BUFFER_DELAY
}
